import { useAuthenticatedMutation } from "@l2r-front/l2r-auth"

export function useRoadworksMutation(
    url,
    axiosFn,
    queryParameters,
    config = {},
) {
    const apiUrl = `roadwork/${url}`

    return useAuthenticatedMutation(
        apiUrl,
        axiosFn,
        { ...queryParameters },
        {
            ...config,
        },
    )
}